import { useCallback } from "react";
import { useFetch2 } from "../../util";

interface IContactsList {
  offset: number;
  limit: number;
  workspaces: number[];
  description?: string;
  name?: string;
  phone?: string;
  email?: string;
  createdAtPeriod?: {
    startAt: string;
    endAt: string;
  };
}

interface ICreateContact {
  name: string;
  phone: string;
  email?: string | null;
  workspaceId: number;
}

interface ICreateContactOutput {
  id: number;
  avatarUrl?: string | null;
}

interface ILoadWhatsappAvatar {
  phone: string;
  dialogId: number;
}

interface ILoadWhatsappAvatarOutput {
  avatarBase64: string;
  avatarFileName: string;
}

interface IAutocompleteContact {
  companyId: number;
  field: "name" | "email" | "phone";
  value: string;
}

interface IContactsListOmnichannel {
  offset: number;
  limit: number;
  workspaces: number[];
  description?: string;
}

type ContactListItem = {
  id: number;
  name: string | null;
  phone: string | null;
  email?: string | null;
  avatarUrl?: string;
};

type ContactListResponse = {
  result: ContactListItem[];
  total: number;
};

export default () => {
  const fetch = useFetch2();

  const ListContacts = async (data: IContactsList) => {
    return fetch<ContactListResponse>(`/api/contacts/list`, { method: "POST" }, data);
  };

  const ListContactsOmnichannel = async (data: IContactsListOmnichannel) => {
    return fetch<ContactListResponse>(`/api/contacts/list-omnichannel`, { method: "POST" }, data);
  };

  const SearchContacts = async (id: number) => {
    return fetch(`/api/contacts/${id}`, { method: "GET" });
  };

  const UpdateContacts = async (id: number, data: any) => {
    const method = { method: "PUT" };
    return fetch(`/api/contacts/${id}`, method, data);
  };

  const CreateContact = async (data: ICreateContact) => {
    return fetch<ICreateContactOutput>(
      `/api/contacts/create`,
      { method: "POST" },
      data
    );
  };

  const LoadWhatsappAvatar = async (data: ILoadWhatsappAvatar) => {
    return fetch<ILoadWhatsappAvatarOutput>(
      `/api/contacts/whatsapp-avatar`,
      { method: "POST" },
      data
    );
  };

  const AutocompleteContact = useCallback(
    async (data: IAutocompleteContact) => {
      return fetch(`/api/contacts/autocomplete`, { method: "POST" }, data);
    },
    [fetch]
  );

  return {
    ListContacts,
    ListContactsOmnichannel,
    SearchContacts,
    UpdateContacts,
    CreateContact,
    LoadWhatsappAvatar,
    AutocompleteContact
  };
};
